var map = {
	"./de/messages.json": [
		671,
		9
	],
	"./el/messages.json": [
		672,
		8
	],
	"./en/messages.json": [
		673,
		7
	],
	"./es/messages.json": [
		674,
		6
	],
	"./fr/messages.json": [
		675,
		5
	],
	"./hu/messages.json": [
		676,
		4
	],
	"./it/messages.json": [
		677,
		3
	],
	"./nl/messages.json": [
		678,
		2
	],
	"./sv/messages.json": [
		679,
		1
	],
	"./tr/messages.json": [
		680,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 568;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./locale lazy ./node_modules/@lingui/loader ^\.\/.*\/messages\.json$
// module id = 568
// module chunks = 10